import { modifier } from 'ember-modifier';
import { isEmpty } from '@ember/utils';
let DEFAULT_DELAY = 0;

// {{focus-on-insert}}
// options
// - selectAllText - will select all the text. default is false
// - delay - adds a delay in milliseconds before the focus occurs. default is 0
// - unless - boolean, if true, the focus will not occur. default is false
// - onlyIfBlank - boolean, if true will only focus if the element.target.value is blank
export default modifier(function focusOnInsert(
  element,
  positionalArgs,
  {
    selectAllText = false,
    delay = DEFAULT_DELAY,
    unless = false,
    onlyIfBlank = false,
  },
) {
  if (unless !== true && (onlyIfBlank !== true || isEmpty(element.value))) {
    setTimeout(() => {
      if (selectAllText) {
        element.select();
      } else {
        element.focus();
      }
    }, delay);
  }
});
